import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { OverlayCard } from "./OverlayCard";
import { SectionTitle } from "./SectionTitle";

export const HeroSlider = ({ items }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setI((x) => (x + 1) % items.length), 7000);
    return () => clearInterval(t);
  }, [items.length]);
  if (!items.length) return null;
  const go = (d) => setI((x) => (x + d + items.length) % items.length);
  return (
    <div>
      <SectionTitle right={
        <div className="flex gap-1">
          <button data-testid="hero-prev-btn" onClick={() => go(-1)} aria-label="Précédent" className="w-8 h-8 border border-zinc-300 bg-white flex items-center justify-center hover:bg-red-600 hover:text-white hover:border-red-600 transition-colors"><ChevronLeft size={16} /></button>
          <button data-testid="hero-next-btn" onClick={() => go(1)} aria-label="Suivant" className="w-8 h-8 border border-zinc-300 bg-white flex items-center justify-center hover:bg-red-600 hover:text-white hover:border-red-600 transition-colors"><ChevronRight size={16} /></button>
        </div>
      }>À la une</SectionTitle>
      <div data-testid="hero-main-story" key={items[i].id} className="fade-up">
        <OverlayCard article={items[i]} size="lg" label="À la une" />
      </div>
      <div className="flex gap-1.5 mt-3 justify-center">
        {items.map((it, idx) => <button key={it.id} onClick={() => setI(idx)} aria-label={`Slide ${idx + 1}`} className={`h-1.5 transition-all ${idx === i ? "w-8 bg-red-600" : "w-3 bg-zinc-300"}`} />)}
      </div>
    </div>
  );
};
